import CustomElement from "./CustomElement";

export default class PageSelect extends CustomElement {
	constructor() {
		super();
    this.select = this.querySelector("select")
    this.select.addEventListener("change", this.handleChange.bind(this))
	}

  handleChange(e) {
    e.preventDefault();
    window.location.href = e.target.value
  }
}